/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".footer-jpl[_ngcontent-%COMP%]{background-color:#222;color:#fff;font-family:Helvetica}.space-taker[_ngcontent-%COMP%]{display:flex;flex-flow:column;flex:1}\n/*# sourceMappingURL=app-footer.component.css.map*/"];
export { styles as styles };
